import React from 'react';
import icon1 from '../../assets/img/serviceExperienced/1.png';
import icon2 from '../../assets/img/serviceExperienced/2.png';
import icon3 from '../../assets/img/serviceExperienced/3.png';
import icon4 from '../../assets/img/serviceExperienced/4.png';

const ServiceExperienced = ({
  title,
  subtitle
}) => {
  const experiences = [
    {
      icon: icon1.src || icon1,
      text: 'Design validation and planning'
    },
    {
      icon: icon2.src || icon2,
      text: 'Interference checks for coordination'
    },
    {
      icon: icon3.src || icon3,
      text: 'Demolition or addition of MEP or construction elements'
    },
    {
      icon: icon4.src || icon4,
      text: 'Documentation of existing building conditions of the Building'
    }
  ];

  return (
    <section className="service-experienced">
      <div className="container">
        <h2 className="experienced-title">
          {title || (
            <>
              <span style={{ color: '#54b248' }}>Experience Point Cloud to</span> BIM Conversion with LOD 100 to 500
            </>
          )}
        </h2>

        {subtitle && (
          <p className="experienced-subtitle">
            {subtitle}
          </p>
        )}

        <div className="experience-grid">
          {experiences.map((item, index) => (
            <div className="experience-card" key={index}>
              <div className="icon-wrapper">
                <img src={item.icon} alt={`Experience Icon ${index + 1}`} />
              </div>
              <p className="card-text">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceExperienced;
